var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCommentUnresolved = function SvgCommentUnresolved(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#FF85C0",
    fillOpacity: 0.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 4H5.2C4.54 4 4 4.54 4 5.2V12.4C4 13.06 4.54 13.6 5.2 13.6H13.1858C13.451 13.6 13.7054 13.7054 13.8929 13.8929L15.1464 15.1464C15.4614 15.4614 16 15.2383 16 14.7929V5.2C16 4.54 15.46 4 14.8 4Z",
    fill: "#FF85C0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCommentUnresolved);
export { ForwardRef as ReactComponent };